export const getSkipSetupParts = (state) => {
  return state?.companySettings?.skipSetupParts ?? false;
};
